import { IConfig } from '../models/Interfaces';

export const Config: IConfig = {
    ApiBaseUrl: process.env.API_BASE_URL ?? 'http://localhost:5050',
    ApplicationName: process.env.APPLICATION_NAME ?? 'rpm-web-frontend',
    FacebookLink: process.env.FACEBOOK_LINK ?? 'https://www.facebook.com/resurrectionpowerministriesofjesus',
    EmailServerEndpoint: process.env.EMAIL_SERVER_ENPOINT ?? 'http://localhost:3738/sendmail',
    AdminEmail: process.env.ADMIN_EMAIL ?? 'admin@theresurrectionpower.org',
};
